export default function Sass_Map() {
  return (
    <div>
      <h1>Sass Map</h1>
    </div>
  );
}
